import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import Tag from '@pedidosya/web-fenix/system/Tag';

import PlusTagContainer from './components/PlusTagContainer';
import Title from './components/Title';
import DeliveryAmountPlus from '../../../DeliveryInfo/components/DeliveryAmountPlus';
import messages from './messages';

const PlusTag = ({
  finalPricePlus,
  originalPricePlus,
  isPickup = false,
  desktopMode = false,
  intl: { formatMessage },
}) => (
  <PlusTagContainer desktopMode={desktopMode} isPickup={isPickup}>
    <Tag category="peya-plus" hasPlus />

    {finalPricePlus > 0 ? (
      <DeliveryAmountPlus
        desktopMode={desktopMode}
        isPickupHeader={isPickup}
        finalPricePlus={finalPricePlus}
        originalPricePlus={originalPricePlus}
      />
    ) : (
      <Title isPickup={isPickup} desktopMode={desktopMode}>
        {isPickup && !desktopMode
          ? formatMessage(messages.plus_delivery_pickup)
          : formatMessage(messages.plus_delivery)}
      </Title>
    )}
  </PlusTagContainer>
);

PlusTag.propTypes = {
  finalPricePlus: PropTypes.number.isRequired,
  originalPricePlus: PropTypes.number.isRequired,
  isPickup: PropTypes.bool,
  desktopMode: PropTypes.bool,
  intl: intlShape.isRequired,
};

export default memo(injectIntl(PlusTag));
